import { Union, Record } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { unit_type, union_type, list_type, record_type, lambda_type, bool_type, class_type, string_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { map, defaultArg, value as value_4 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { map as map_1, empty, singleton, append, tryFind, fold, head as head_6, tail as tail_6, length, isEmpty } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { GlobalMsg, GlobalMessageBox, GlobalMessageBoxButton, GlobalMessageBoxButtonType, GlobalMessageType } from "./Types.fs.js";
import * as react from "react";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty as empty_1, collect, singleton as singleton_1, append as append_1, delay, toList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Seq.js";
import { DOMAttr, HTMLAttr } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { join } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { rangeDouble } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Range.js";

export class UploadFileType_Type extends Record {
    constructor(MimeType, Label, IsValid) {
        super();
        this.MimeType = MimeType;
        this.Label = Label;
        this.IsValid = IsValid;
    }
}

export function UploadFileType_Type_$reflection() {
    return record_type("Bfs.Web.Portale.UploadBox.UploadFileType.Type", [], UploadFileType_Type, () => [["MimeType", string_type], ["Label", string_type], ["IsValid", lambda_type(class_type("Browser.Types.File", undefined), bool_type)]]);
}

export const UploadFileType_Pdf = new UploadFileType_Type("application/pdf", "PDF", (file) => (file.type === "application/pdf"));

export const UploadFileType_Image = new UploadFileType_Type("image/jpeg,image/png", "Bild", (file) => ((file.type === "image/jpeg") ? true : (file.type === "image/png")));

export class Accept extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All", "Only"];
    }
}

export function Accept_$reflection() {
    return union_type("Bfs.Web.Portale.UploadBox.Accept", [], Accept, () => [[], [["Item", list_type(UploadFileType_Type_$reflection())]]]);
}

export class ConfirmSettings extends Record {
    constructor(IsSending, CanConfirm, ConfirmUpload) {
        super();
        this.IsSending = IsSending;
        this.CanConfirm = CanConfirm;
        this.ConfirmUpload = ConfirmUpload;
    }
}

export function ConfirmSettings_$reflection() {
    return record_type("Bfs.Web.Portale.UploadBox.ConfirmSettings", [], ConfirmSettings, () => [["IsSending", bool_type], ["CanConfirm", bool_type], ["ConfirmUpload", lambda_type(unit_type, unit_type)]]);
}

export const UploadBox = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_4("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Portale\\UploadBox.fs") + "#L") + int32ToString(value_4(42))) + ";") + "System.Tuple`7[Bfs.Web.Portale.UploadBox.Accept,Microsoft.FSharp.Core.FSharpFunc`2[Microsoft.FSharp.Collections.FSharpList`1[Browser.Types.File],Microsoft.FSharp.Core.Unit],Microsoft.FSharp.Core.FSharpFunc`2[Bfs.Web.Data.Service.Contracts.UploadResult,Microsoft.FSharp.Core.Unit],Microsoft.FSharp.Collections.FSharpList`1[Bfs.Web.Data.Service.Contracts.UploadResult],System.Int32,Microsoft.FSharp.Core.FSharpOption`1[Bfs.Web.Portale.UploadBox.ConfirmSettings],Microsoft.FSharp.Core.FSharpFunc`2[Types.GlobalMsg,Microsoft.FSharp.Core.Unit]]", value_4("UploadBox"), (tupledArg) => {
    let children_43, children_10, props_8, children_41;
    const accept = tupledArg[0];
    const upload = tupledArg[1];
    const fileList = tupledArg[3];
    const uploadCount = tupledArg[4] | 0;
    const confirmSettings = tupledArg[5];
    const isLoading = defaultArg(map((item) => item.IsSending, confirmSettings), false) ? " is-loading" : "";
    const uploadHintRestricted = (allowedTypes) => {
        let matchResult, head_3, tail_3, head_4, tail_4, head_5, tail_5;
        if (!isEmpty(allowedTypes)) {
            if (length(tail_6(allowedTypes)) > 1) {
                matchResult = 0;
                head_3 = head_6(allowedTypes);
                tail_3 = tail_6(allowedTypes);
            }
            else if (length(tail_6(allowedTypes)) === 1) {
                matchResult = 1;
                head_4 = head_6(allowedTypes);
                tail_4 = tail_6(allowedTypes);
            }
            else if (length(tail_6(allowedTypes)) === 0) {
                matchResult = 2;
                head_5 = head_6(allowedTypes);
                tail_5 = tail_6(allowedTypes);
            }
            else {
                matchResult = 3;
            }
        }
        else {
            matchResult = 3;
        }
        switch (matchResult) {
            case 0:
                return `${head_3.Label}-, ${uploadHintRestricted(tail_3)}`;
            case 1:
                return `${head_4.Label}- oder ${uploadHintRestricted(tail_4)}`;
            case 2:
                return `${head_5.Label} Dateien`;
            default:
                return "";
        }
    };
    const uploadHint = (accept.tag === 1) ? uploadHintRestricted(accept.fields[0]) : "Dateien";
    const removeInvalidFiles = (filelist) => {
        let children_4, children_2;
        const patternInput = fold((tupledArg_1, file_2) => {
            const valid = tupledArg_1[0];
            const invalid = tupledArg_1[1];
            const matchValue_1 = (file_2.size > 0) ? undefined : "leere Datei";
            const matchValue_2 = (accept.tag === 1) ? ((tryFind((acceptedType) => acceptedType.IsValid(file_2), accept.fields[0]) != null) ? undefined : "falsches Dateiformat") : undefined;
            let matchResult_1, error, error_1;
            if (matchValue_1 != null) {
                if (matchValue_2 != null) {
                    matchResult_1 = 1;
                    error = matchValue_2;
                }
                else {
                    matchResult_1 = 2;
                    error_1 = matchValue_1;
                }
            }
            else if (matchValue_2 != null) {
                matchResult_1 = 1;
                error = matchValue_2;
            }
            else {
                matchResult_1 = 0;
            }
            switch (matchResult_1) {
                case 0:
                    return [append(valid, singleton(file_2)), invalid];
                case 1:
                    return [valid, append(invalid, singleton([file_2, error]))];
                default:
                    return [valid, append(invalid, singleton([file_2, error_1]))];
            }
        }, [empty(), empty()], filelist);
        const invalid_1 = patternInput[1];
        if (!isEmpty(invalid_1)) {
            tupledArg[6](new GlobalMsg(3, [new GlobalMessageBox(new GlobalMessageType(3, []), "Dateiupload", (children_4 = ["Folgende Dateien werden können nicht hinzugefügt werden:", (children_2 = map_1((tupledArg_2) => {
                const children = [`${tupledArg_2[0].name} (${tupledArg_2[1]})`];
                return react.createElement("li", {}, ...children);
            }, invalid_1), react.createElement("ul", {
                className: "failed-upload-list",
            }, ...children_2))], react.createElement("div", {}, ...children_4)), singleton(new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "OK", undefined, true)))]));
        }
        return patternInput[0];
    };
    const children_45 = [(children_43 = [(children_10 = [react.createElement("i", {
        className: "fas fa-upload fa-4x",
    }), (props_8 = [["style", {
        padding: "1em",
    }]], react.createElement("p", keyValueList(props_8, 1), "Dateien hier ablegen"))], react.createElement("div", {
        id: "dropoverlay",
        className: "dropoverlay",
    }, ...children_10)), (children_41 = toList(delay(() => {
        let children_26, children_24, props_12, children_22, children_14, children_20;
        return append_1(singleton_1((children_26 = [(children_24 = [(props_12 = [new HTMLAttr(65, ["file-input"]), new HTMLAttr(159, ["file"]), new HTMLAttr(121, [true]), (accept.tag === 0) ? (new HTMLAttr(2, ["*"])) : (new HTMLAttr(2, [join(",", map_1((acceptedType_1) => acceptedType_1.MimeType, accept.fields[0]))])), new DOMAttr(9, [(ev_3) => {
            const files = ev_3.target.files;
            const fileList_2 = removeInvalidFiles(map_1((i_1) => files[i_1], toList(rangeDouble(0, 1, files.length - 1))));
            if (!isEmpty(fileList_2)) {
                upload(fileList_2);
            }
        }])], react.createElement("input", keyValueList(props_12, 1))), (children_22 = [(children_14 = [react.createElement("i", {
            className: "fas fa-upload fa-4x",
        })], react.createElement("span", {
            className: "file-icon",
        }, ...children_14)), (children_20 = [react.createElement("span", {
            className: "is-hidden-touch",
        }, `${uploadHint} auf diese Fläche ziehen oder hier klicken`), react.createElement("span", {
            className: "is-hidden-desktop",
        }, `Hier klicken um ${uploadHint} hinzuzufügen`)], react.createElement("span", {
            className: "file-label",
        }, ...children_20))], react.createElement("span", {
            className: "file-cta",
        }, ...children_22))], react.createElement("label", {
            className: "file-label",
        }, ...children_24))], react.createElement("div", {
            className: "file is-boxed",
        }, ...children_26))), delay(() => {
            let children_36;
            return append_1((!isEmpty(fileList) ? true : (uploadCount > 0)) ? singleton_1((children_36 = toList(delay(() => append_1(map_1((item_1) => {
                const children_32 = [react.createElement("div", {
                    className: "file-name-left ellipsis",
                    title: item_1.Dateiname,
                }, item_1.Dateiname), react.createElement("a", {
                    className: "fas fa-trash-alt",
                    title: "löschen",
                    onClick: (_arg_1) => {
                        tupledArg[2](item_1);
                    },
                })];
                return react.createElement("div", {
                    className: "file-list-item",
                }, ...children_32);
            }, fileList), delay(() => ((uploadCount > 0) ? collect((matchValue_4) => singleton_1(react.createElement("p", {}, "wird hochgeladen...")), toList(rangeDouble(0, 1, uploadCount - 1))) : empty_1()))))), react.createElement("div", {
                className: "file-list",
            }, ...children_36))) : empty_1(), delay(() => {
                let settings, settings_1, props_40;
                return (confirmSettings != null) ? (((settings = confirmSettings, !isEmpty(fileList))) ? ((settings_1 = confirmSettings, singleton_1((props_40 = [new HTMLAttr(65, ["bfsbutton wide" + isLoading]), new HTMLAttr(79, [!settings_1.CanConfirm]), new DOMAttr(40, [(_arg_2) => {
                    settings_1.ConfirmUpload();
                }])], react.createElement("button", keyValueList(props_40, 1), "Versenden"))))) : singleton_1(react.createElement(react.Fragment, {}))) : singleton_1(react.createElement(react.Fragment, {}));
            }));
        }));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_41))], react.createElement("div", {
        onDrop: (ev) => {
            ev.preventDefault();
            document.getElementById("dropoverlay").classList.remove("dragging");
            const dataTransferItemList = ev.dataTransfer.items;
            const fileList_1 = removeInvalidFiles(map_1((i) => (ev.dataTransfer.items[i]).getAsFile(), toList(rangeDouble(0, 1, dataTransferItemList.length - 1))));
            if (!isEmpty(fileList_1)) {
                upload(fileList_1);
            }
        },
        onDragEnter: (_arg) => {
            document.getElementById("dropoverlay").classList.add("dragging");
        },
        onDragLeave: (ev_1) => {
            if (ev_1.target.id === "dropoverlay") {
                document.getElementById("dropoverlay").classList.remove("dragging");
            }
        },
        onDragOver: (ev_2) => {
            ev_2.preventDefault();
        },
    }, ...children_43))];
    return react.createElement("div", {
        className: "flat-card profile-info-card is-auto upload-box",
    }, ...children_45);
}, undefined, undefined, "Of");

//# sourceMappingURL=UploadBox.fs.js.map
